// import fun
const _import = require('../_import')
// scope rent
const scope = 'service'

export default {
    path: '/service',
    name: 'service',
    component: _import(`${scope}`),
    children: [
      {
        path: 'repair',
        name: 'repair',
        component: _import(`${scope}/repair`)
      },
      {
        path: 'clean',
        name: 'clean',
        component: _import(`${scope}/clean`)
      },
      {
        path: 'maintain',
        name: 'maintain',
        component: _import(`${scope}/maintain`)
      },
      {
        path: 'electric',
        name: 'electric',
        component: _import(`${scope}/electric`)
      },
      {
        path: 'lock',
        name: 'lock',
        component: _import(`${scope}/lock`)
      },
      {
        path: 'water',
        name: 'water',
        component: _import(`${scope}/water`)
      }
    ]
}



// WEBPACK FOOTER //
// ./src/router/modules/service.js